export default theme => ({
  asset__border: {
    border: `1px solid ${theme.palette.primary.light}`,
    boxShadow: theme.shadows[2],
  },
});
